import { createSelector } from "reselect";

const selectedLeftMenu = state => state.leftMenu;
export const selectLeftMenuItems = createSelector([selectedLeftMenu], selectedLeftMenu => selectedLeftMenu.menuItems);

const rootReducerSelector = state => state.rootReducer;
export const selectUserDetails = createSelector([rootReducerSelector], rootReducer => rootReducer.currentUserDetails);
